export default "__VITE_ASSET__129cab61__"